import React, { useState } from 'react';
import { Modal } from './Modal';
import { GuaranteeIcon } from './icons/CustomIcons';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | 'guarantee' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <footer className="w-full py-8 px-4 md:px-8 lg:px-16 bg-[#0c2340] text-white" data-id="element-81">
      <div className="max-w-6xl mx-auto" data-id="element-82">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-83">
          <div className="mb-6 md:mb-0" data-id="element-84">
            <h3 className="text-xl font-bold text-[#e9d28f]" data-id="element-85">
              Unshakable Conviction
            </h3>
            <p data-id="element-86">© 2025 All Rights Reserved</p>
          </div>
          <div className="flex flex-wrap gap-6" data-id="element-87">
            <button onClick={() => setActiveModal('guarantee')} className="flex items-center hover:text-[#e9d28f] transition duration-300 cursor-pointer" data-id="element-88">
              <GuaranteeIcon className="w-5 h-5 mr-1 text-[#e9d28f]" data-id="element-89" />
              30 Days Guaranteed
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-[#e9d28f] transition duration-300 cursor-pointer" data-id="element-90">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-[#e9d28f] transition duration-300 cursor-pointer" data-id="element-91">
              Terms of Service
            </button>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-700 text-center text-sm text-gray-400" data-id="element-92">
          <p data-id="element-93">
            This is a promotional page for a book. All rights reserved. All
            trademarks are property of their respective owners.
          </p>
        </div>
      </div>
      {/* 30-Day Guarantee Modal */}
      <Modal isOpen={activeModal === 'guarantee'} onClose={closeModal} title="30-Day Return Policy" data-id="element-94">
        <div className="space-y-4" data-id="element-95">
          <p data-id="element-96">
            We want you to be fully satisfied with your purchase of Unshakable
            Conviction. Please review the following return policy, which applies
            only to physical book orders:
          </p>
          <h4 className="font-bold mt-4" data-id="element-97">Eligibility</h4>
          <p data-id="element-98">
            Returns are accepted within 30 days of delivery. The book must be in
            its original, unused, and resalable condition (no marks, wear, or
            damage).
          </p>
          <h4 className="font-bold mt-4" data-id="element-99">Non-Returnable Items</h4>
          <p data-id="element-100">
            Opened, used, or damaged books (including bent covers, torn pages,
            or water damage) are not eligible for return. Digital editions are
            non-refundable.
          </p>
          <h4 className="font-bold mt-4" data-id="element-101">Return Process</h4>
          <p data-id="element-102">
            To request a return, you must contact our support team first to
            receive a return authorization. Unauthorized returns will not be
            accepted.
          </p>
          <h4 className="font-bold mt-4" data-id="element-103">Return Shipping</h4>
          <p data-id="element-104">
            Customers are responsible for all return shipping costs, including
            proper packaging to ensure the book arrives undamaged. We recommend
            using a trackable shipping service.
          </p>
          <h4 className="font-bold mt-4" data-id="element-105">Refunds</h4>
          <p data-id="element-106">
            Once your return is received and inspected, a refund will be issued
            for the book price minus original shipping and handling fees.
            Refunds may take up to 10 business days to process.
          </p>
          <h4 className="font-bold mt-4" data-id="element-107">Exchanges</h4>
          <p data-id="element-108">
            We do not offer direct exchanges. If you wish to receive another
            copy, please place a new order after your return is approved.
          </p>
          <h4 className="font-bold mt-4" data-id="element-109">Damaged or Defective Items</h4>
          <p data-id="element-110">
            If your book arrives damaged due to shipping, please contact us
            within 7 days of delivery with photos, and we will arrange a
            replacement at no additional cost.
          </p>
        </div>
      </Modal>
      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Privacy Policy" data-id="element-111">
        <div className="space-y-4" data-id="element-112">
          <h3 className="text-lg font-bold" data-id="element-113">
            Privacy Policy for Unshakable Conviction
          </h3>
          <p className="text-sm text-gray-700" data-id="element-114">Last Updated: September 2025</p>
          <h4 className="font-bold mt-4" data-id="element-115">1. Information We Collect</h4>
          <p data-id="element-116">
            We collect information you provide directly to us when you purchase
            our book, including your name, billing information, shipping
            address, and contact details.
          </p>
          <h4 className="font-bold mt-4" data-id="element-117">2. How We Use Your Information</h4>
          <p data-id="element-118">We use your information to:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-119">
            <li data-id="element-120">Process and fulfill your order</li>
            <li data-id="element-121">Send you order confirmations and updates</li>
            <li data-id="element-122">Respond to your questions and comments</li>
            <li data-id="element-123">
              Send promotional emails about new releases or special offers (you
              may opt out)
            </li>
          </ul>
          <h4 className="font-bold mt-4" data-id="element-124">3. Information Sharing</h4>
          <p data-id="element-125">
            We do not sell or rent your personal information to third parties.
            We may share your information with service providers who assist in
            our operations, such as payment processors and shipping companies.
          </p>
          <h4 className="font-bold mt-4" data-id="element-126">4. Security</h4>
          <p data-id="element-127">
            We implement appropriate security measures to protect your personal
            information from unauthorized access or disclosure.
          </p>
          <h4 className="font-bold mt-4" data-id="element-128">5. Your Choices</h4>
          <p data-id="element-129">
            You may opt out of receiving promotional emails by following the
            unsubscribe instructions in the emails or contacting us directly.
          </p>
          <h4 className="font-bold mt-4" data-id="element-130">6. Contact Us</h4>
          <p data-id="element-131">
            If you have questions about this Privacy Policy, please contact us
            at privacy@unshakableconviction.com
          </p>
        </div>
      </Modal>
      {/* Terms of Service Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={closeModal} title="Terms of Service" data-id="element-132">
        <div className="space-y-4" data-id="element-133">
          <h3 className="text-lg font-bold" data-id="element-134">
            Terms of Service for Unshakable Conviction
          </h3>
          <p className="text-sm text-gray-700" data-id="element-135">Last Updated: September 2025</p>
          <h4 className="font-bold mt-4" data-id="element-136">1. Acceptance of Terms</h4>
          <p data-id="element-137">
            By accessing or using our website and purchasing our book, you agree
            to be bound by these Terms of Service.
          </p>
          <h4 className="font-bold mt-4" data-id="element-138">2. Purchases</h4>
          <p data-id="element-139">
            All purchases are final. We offer a 30-day money-back guarantee if
            you are not satisfied with your purchase.
          </p>
          <h4 className="font-bold mt-4" data-id="element-140">3. Shipping and Delivery</h4>
          <p data-id="element-141">
            Physical books are typically shipped within 3-5 business days.
            Delivery times vary based on location. Digital copies are delivered
            via email immediately after purchase.
          </p>
          <h4 className="font-bold mt-4" data-id="element-142">4. Intellectual Property</h4>
          <p data-id="element-143">
            All content in "Unshakable Conviction" is protected by copyright
            laws. You may not reproduce, distribute, or create derivative works
            without our express permission.
          </p>
          <h4 className="font-bold mt-4" data-id="element-144">5. User Conduct</h4>
          <p data-id="element-145">
            You agree not to use our website for any unlawful purpose or in any
            way that could damage or impair the site's functionality.
          </p>
          <h4 className="font-bold mt-4" data-id="element-146">6. Limitation of Liability</h4>
          <p data-id="element-147">
            We are not liable for any indirect, incidental, or consequential
            damages arising from your use of our website or products.
          </p>
          <h4 className="font-bold mt-4" data-id="element-148">7. Governing Law</h4>
          <p data-id="element-149">
            These Terms are governed by the laws of the United States and the
            state of Arizona.
          </p>
          <h4 className="font-bold mt-4" data-id="element-150">8. Changes to Terms</h4>
          <p data-id="element-151">
            We may update these Terms from time to time. It is your
            responsibility to review them periodically.
          </p>
        </div>
      </Modal>
    </footer>;
}